import React from "react";
import { IoWarning } from "react-icons/io5";
import { numberWithCommas } from "src/utils";

const TransactionCard = ({ bookingTrx }: { bookingTrx: BookingTrnxType[] }) => {
  const totalAmount = bookingTrx
    .map((item) => item.amount)
    .reduce((a, b) => a + b, 0);

  // Copy the array so we don't mutate the original state
  // Create a new array with new objects
  const processedBookingTrx = bookingTrx.map((item) => ({ ...item }));

  if (processedBookingTrx.length >= 2) {
    // Create a new object for the second item with updated amount
    processedBookingTrx[3] = {
      ...processedBookingTrx[3],
      amount: processedBookingTrx[1]?.amount + processedBookingTrx[3]?.amount || 0,
    };

    // Remove the first item
    processedBookingTrx.splice(1, 1);
  }

  return (
    <div className="flex flex-col gap-2 py-[18px]">
      <h5 className="font-semibold text-[#4D4D4D]">Booking Transaction</h5>
      <div className="w-full">
        <h6 className="font-semibold text-[#4D4D4D] mb-2">Invoices</h6>
        {bookingTrx.length > 0 ? (
          <div className="flex flex-col gap-4">
            {processedBookingTrx.map((item) => (
              <div
                key={item._id}
                className="bg-[#F2F2F2] rounded-xl px-4 py-3 flex flex-col gap-1"
              >
                <div className="flex justify-between items-center">
                  <span className="text-[#999] text-sm">Fee</span>
                  <span className="font-semibold text-[#4D4D4D] text-base">
                    {item.narration}
                  </span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-[#b9a4a4] text-sm">Amount:</span>
                  <span className="font-semibold text-[#4D4D4D] text-base">
                    ₦{item.amount ? numberWithCommas(item.amount) : 0}
                  </span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-[#999] text-sm">Status:</span>
                  <span className="font-semibold text-[#4D4D4D] text-base capitalize">
                    {item.status}
                  </span>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="flex gap-2 justify-center items-center px-2">
            <span className="text-xs px-5 py-3 flex items-center leading-5 rounded-lg bg-gray-50 text-gray-500">
              <IoWarning size={15} /> No available transactions
            </span>
          </div>
        )}
        {/* Total Amount */}
        {bookingTrx.length > 0 && (
          <div className="flex justify-end mt-4">
            <span className="text-sm text-[#7607BD] font-semibold">
              Total Amount &nbsp;
              <span className="text-[16px] font-bold text-[#7607BD]">
                ₦{numberWithCommas(totalAmount)}
              </span>
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default TransactionCard;
